import { render, staticRenderFns } from "./TableResults.vue?vue&type=template&id=6075d4a6&scoped=true&"
import script from "./TableResults.vue?vue&type=script&lang=js&"
export * from "./TableResults.vue?vue&type=script&lang=js&"
import style0 from "./TableResults.vue?vue&type=style&index=0&id=6075d4a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6075d4a6",
  null
  
)

export default component.exports